const fiatList = [
  { value: "btc", label: "Bitcoin" },
  { value: "eth", label: "Ethereum" },
  { value: "ltc", label: "Litecoin" },
  { value: "bch", label: "Bitcoin Cash" },
  { value: "bnb", label: "Binance Coin" },
  { value: "eos", label: "EOS" },
  { value: "xrp", label: "Ripple" },
  { value: "xlm", label: "Stellar" },
  { value: "link", label: "Chainlink" },
  { value: "dot", label: "Polkadot" },
  { value: "yfi", label: "Yearn.finance" },
  { value: "usd", label: "US Dollar" },
  { value: "aed", label: "UAE Dirham" },
  { value: "ars", label: "Argentine Peso" },
  { value: "aud", label: "Australian Dollar" },
  { value: "bdt", label: "Bangladeshi Taka" },
  { value: "bhd", label: "Bahraini Dinar" },
  { value: "bmd", label: "Bermudan Dollar" },
  { value: "brl", label: "Brazilian Real" },
  { value: "cad", label: "Canadian Dollar" },
  { value: "chf", label: "Swiss Franc" },
  { value: "clp", label: "Chilean Peso" },
  { value: "cny", label: "Chinese Yuan" },
  { value: "czk", label: "Czech Koruna" },
  { value: "dkk", label: "Danish Krone" },
  { value: "eur", label: "Euro" },
  { value: "gbp", label: "British Pound" },
  { value: "gel", label: "Georgian Lari" },
  { value: "hkd", label: "Hong Kong Dollar" },
  { value: "huf", label: "Hungarian Forint" },
  { value: "idr", label: "Indonesian Rupiah" },
  { value: "ils", label: "Israeli New Shekel" },
  { value: "inr", label: "Indian Rupee" },
  { value: "jpy", label: "Japanese Yen" },
  { value: "krw", label: "South Korean Won" },
  { value: "kwd", label: "Kuwaiti Dinar" },
  { value: "lkr", label: "Sri Lankan Rupee" },
  { value: "mmk", label: "Myanmar Kyat" },
  { value: "mxn", label: "Mexican Peso" },
  { value: "myr", label: "Malaysian Ringgit" },
  { value: "ngn", label: "Nigerian Naira" },
  { value: "nok", label: "Norwegian Krone" },
  { value: "nzd", label: "New Zealand Dollar" },
  { value: "php", label: "Philippine Peso" },
  { value: "pkr", label: "Pakistani Rupee" },
  { value: "pln", label: "Polish Złoty" },
  { value: "rub", label: "Russian Ruble" },
  { value: "sar", label: "Saudi Riyal" },
  { value: "sek", label: "Swedish Krona" },
  { value: "sgd", label: "Singapore Dollar" },
  { value: "thb", label: "Thai Baht" },
  { value: "try", label: "Turkish Lira" },
  { value: "twd", label: "New Taiwan Dollar" },
  { value: "uah", label: "Ukrainian Hryvnia" },
  { value: "vef", label: "Venezuelan Bolívar Fuerte" },
  { value: "vnd", label: "Vietnamese Đồng" },
  { value: "zar", label: "South African Rand" },
  { value: "xdr", label: "Special Drawing Rights" },
  { value: "xag", label: "Silver" },
  { value: "xau", label: "Gold" },
  { value: "bits", label: "Bits" },
  { value: "sats", label: "Satoshis" }
];


  export default fiatList;